<template>
  <div class="view contentBody">
    <div class="content">
      <!--<div class="content-tab-box">-->
        <!--<span :class="tabCurrent==1?'content-tab-box-active':''" @click="tabCurrentFn(1)">订单管理</span>-->
        <!--<span :class="tabCurrent==2?'content-tab-box-active':''" @click="tabCurrentFn(2)">售后管理</span>-->
        <!--<span :class="tabCurrent==3?'content-tab-box-active':''" @click="tabCurrentFn(3)">员工订单</span>-->
      <!--</div>-->
      <!--<div>-->
        <!--<orderManagementList v-if="tabCurrent==1"></orderManagementList>-->
        <!--<aftersalesManagementList v-if="tabCurrent==2"></aftersalesManagementList>-->
        <!--<employeeOrderList v-if="tabCurrent==3"></employeeOrderList>-->
      <!--</div>-->
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
import aftersalesManagementList from "./aftersalesManagementList.vue";
import employeeOrderList from "./employeeOrderList.vue";
import orderManagementList from "./orderManagementList.vue";
import customOrderList from "./customOrderList.vue";
let tabBox = {
  '订单管理': {property: 'orderManagementList'},
  '售后管理': {property: 'aftersalesManagementList'},
  '定制订单': {property: 'customOrderList'},
  // '员工订单': {property: 'employeeOrderList'}
}

export default {
  name: "order",
  components: {
    aftersalesManagementList,
    employeeOrderList,
    orderManagementList
  },
  data() {
    return {
      meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      activeName:''
    };
  },
  created() {
    this.inittab();
  },
  methods: {
    inittab() {
      this.activeName =
        this.$route.query.tab !== undefined
          ? this.$route.query.tab
          : "orderManagementList";
    },
    tabCurrentFn(index){
      this.meaulistTab.firstTab = index
    }
  }
};
</script>
